import { createContext } from 'react';

export type OpenBankingSignupFlow = (initialStepId?: string) => void;

export const BankingSignupModalContext =
  createContext<OpenBankingSignupFlow | null>(null);
